import { Project } from "@radarly/models/project";
import { useCanAccessProjectFromCurrentUserLevel } from "./useCanAccessProjectFromCurrentUserLevel";
import { useGetCurrentUserProjectData } from "./useGetCurrentUserProjectData";

export function useCanAccessProject(project: Project) {
  const canAccessProjectFromCurrentUserLevel = useCanAccessProjectFromCurrentUserLevel(
    project
  );
  const userProjectData = useGetCurrentUserProjectData(project?.id);
  return canAccessProjectFromCurrentUserLevel || !!userProjectData;
}
